import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b296a8bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "logo-background"
};
import { ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoIcon',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          title: '',
          link: '',
          normalIcon: '',
          hoverIcon: ''
        };
      }
    }
  },
  setup(__props) {
    const props = __props;
    const ishover = ref(false);
    const bgImg = ref(props.data.normalIcon);
    const onMouseEnter = () => {
      //bgImg.value=props.data.normalIcon
      ishover.value = true;
    };
    const onMouseLeave = () => {
      //bgImg.value=props.data.hoverIcon
      ishover.value = false;
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", {
        class: "logo-container flex-col",
        onMouseenter: onMouseEnter,
        onMouseleave: onMouseLeave
      }, [_createVNode(_component_router_link, {
        to: __props.data.link
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: "logo imgbg-contain",
          style: _normalizeStyle('background-image: url(' + bgImg.value + ');')
        }, null, 4)]), _createElementVNode("div", {
          class: _normalizeClass(["title", {
            selected: ishover.value
          }])
        }, _toDisplayString(_ctx.$t(__props.data.title)), 3)]),
        _: 1
      }, 8, ["to"])], 32);
    };
  }
});